import { FC } from 'react';
import { Button, ControlUnit } from '@features/ui';
import { useTranslation } from 'react-i18next';

interface DownloadedProps {
  src: string;
  onDownload?: () => void;
}
export const Downloaded: FC<DownloadedProps> = ({ src, onDownload }) => {
  const { t } = useTranslation();

  return (
    <div className={'flex justify-between'}>
      <div>
        <ControlUnit
          active
          className={'text-xs w-fit text-[#14CA74] px-[6px]'}
          value={t('downloads.included')}
        />
        <img
          alt={'platform'}
          className={'w-[235px] h-auto mt-6 mb-13'}
          src={src}
        />
      </div>
      <Button variant={'gradient'} onClick={onDownload}>
        {t('downloads.platformDownload')}
      </Button>
    </div>
  );
};
